/** A code for a QR that is printed. Unlike the rotating code it keeps working until `expiresAt` (8 hours). */
export class CheckInPrintCode {
  constructor(
    public readonly code: string,
    /** What the QR contains: `dijkgraaf://check-in?c=<check-in uuid>&k=<code>`. */
    public readonly qrPayload: string,
    public readonly expiresAt: Date,
  ) {}

  static fromJson(json: any): CheckInPrintCode {
    return new CheckInPrintCode(json["code"], json["qr_payload"], new Date(json["expires_at"]));
  }
}
